import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.config.productionTip = false

Vue.config.errorHandler = () => {
  router.push({ name: 'rep085' })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
